const mensLeaguesData = {
  "Prem Division": {
    "name": "Prem Division",
    "config": {
      "ticketPrice": 60,
      "stadiumCapacity": 40000
    }
  },
  "First Division": {
    "name": "First Division",
    "config": {
      "ticketPrice": 40,
      "stadiumCapacity": 25000
    }
  },
  "League One": {
    "name": "League One",
    "config": {
      "ticketPrice": 30,
      "stadiumCapacity": 12000
    }
  },
  "League Two": {
    "name": "League Two",
    "config": {
      "ticketPrice": 25,
      "stadiumCapacity": 8000
    }
  }
};

export default mensLeaguesData;
